export const SERVICE_NAMESPACE = 'price-automation-service';
export const VMDS_ENDPOINT_URL = '/vmds-highlights-api/v1/highlights/';
